var React = require('react');

function WComeFunziona (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#EFF8F7","fillOpacity":"1","d":"M0,128L48,154.7C96,181,192,235,288,245.3C384,256,480,224,576,218.7C672,213,768,235,864,245.3C960,256,1056,256,1152,240C1248,224,1344,192,1392,176L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"}));
}

WComeFunziona.defaultProps = {"viewBox":"0 0 1440 320"};

module.exports = WComeFunziona;

WComeFunziona.default = WComeFunziona;
